import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from '@material-ui/core/styles';
import {getDashOrderListByUserid,setofUpdatedashboardOrderTV,decrypt,encrypt } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
  const { authUser} = auth;
  const { OrderStatusList,updatedashboardOrderTY} = accountsData;
    const { DashOrderList,DashboardAnpassadFilterOption} = DashBoard;
    return {
        authUser,DashOrderList,DashboardAnpassadFilterOption,OrderStatusList,updatedashboardOrderTY
    };
}

function mapDispatchToProps(dispatch) {
  return {
    getDashOrderListByUserid: (userid,Afid,DashboardAnpassadFilterOption,intervaltype) => dispatch(getDashOrderListByUserid(userid,Afid,DashboardAnpassadFilterOption,intervaltype)),
    setofUpdatedashboardOrderTV: () => dispatch(setofUpdatedashboardOrderTV()),
      dispatch
  }
}
const useStyles = theme => ({
  root: {
      '&::-webkit-scrollbar': {
          width: '5px'
        },
         
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
         
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#12484B',
          outline: '1px solid transparent'
        }
   },
});
class OrderTable extends Component {
  state={
    DashOrderList:[],
    DashboardAnpassadFilterOption:[],
    done: true
  }
  intervalID = null
componentDidMount=()=>{
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  axios.get(`kontos/DashBoard/getOLBU`,
      { params:encrypt(JSON.stringify({
          Afid:Afid,
          FilterOption:[],
          intervaltype:this.props.intervaltype,
          userid:userid
        }))
      })
      .then(res => {
         if(res.data.success){
                                let endata = decrypt(res.data.encryptedData,res.data.iv)
                                let ndate = JSON.parse(endata)
                                this.setState({ 
                                  DashOrderList:ndate.results.OrderList
                               });
                            this.initiateInterval() 
                         //  this.setState({done: true})  
                            }
      
})
}
initiateInterval() {
    clearInterval(this.intervalID);
    this.intervalID= null
  this.intervalID = setInterval(
    () => {
      if(this.state.done === true){            
       // this.setState({done: false})  
      const userid = this.props.authUser.user_id;
      const Afid = this.props.authUser.user_Afid;
      axios.get(`kontos/DashBoard/getOLBU`,
      { params:encrypt(JSON.stringify({
          Afid:Afid,
          FilterOption:[],
          intervaltype:this.props.intervaltype,
          userid:userid
        }))
      })
      .then(res => {
        if(res.data.success){
          let endata = decrypt(res.data.encryptedData,res.data.iv)
          let ndate = JSON.parse(endata)
          this.setState({ 
            DashOrderList:ndate.results.OrderList
         });
      this.initiateInterval() 
   //  this.setState({done: true})  
      }
    })
  }
    },
    180000
);
 console.log('test1234567', this.props.height)
}
componentWillUnmount() {
  clearInterval(this.intervalID);
  this.intervalID= null
}
componentDidUpdate=()=>{
  const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    if(parseInt(this.props.updatedashboardOrderTY) === 1){
            
      axios.get(`kontos/DashBoard/getOLBU`,
      { params:encrypt(JSON.stringify({
          Afid:Afid,
          FilterOption:[],
          intervaltype:this.props.intervaltype,
          userid:userid
        }))
      })
      .then(res => {
        if(res.data.success){
          let endata = decrypt(res.data.encryptedData,res.data.iv)
          let ndate = JSON.parse(endata)
          this.setState({ 
            DashOrderList:ndate.results.OrderList
         });
      this.initiateInterval() 
   //  this.setState({done: true})  
      }
    })
      this.props.setofUpdatedashboardOrderTV()
  }
  
}
getStalus=(status,Hogia,Afid)=>{
  console.log('test26524555', status)
  console.log('test26524555', this.props.OrderStatusList)
  if (!isEmpty(Hogia)){
    switch(status){
      case 1: return (
        <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className=" my-2"><p style={{ margin: '0 auto', fontSize: 14, fontWeight: '600', color: '#FFC895' }}><IntlMessages id="Order.status.Hogia.onGoing"/></p></div>
        // <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="bg-primary text-white d-flex align-items-center my-2"><p style={{ margin: '0 auto', fontSize: 14 }}><IntlMessages id="Order.status.Hogia.onGoing"/></p></div>
        ) 
        default: return (
        <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className=" my-2"><p style={{ margin: '0 auto', fontSize: 14, fontWeight: '600', color: '#93F8B3' }}><IntlMessages id="Order.status.Hogia.Done"/></p></div>
        // <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="bg-success text-white d-flex align-items-center my-2"><p style={{ margin: '0 auto', fontSize: 14 }}><IntlMessages id="Order.status.Hogia.Done"/></p></div>
        )
    }
  } 
  if(isEmpty(this.props.OrderStatusList)){
  if (status === 2) return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 14, fontWeight: '600', color: '#13E0EB' }}><IntlMessages id="Order.status.new"/></p></div>
  if (status === 3) return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 14, fontWeight: '600', color: '#FFC895' }}><IntlMessages id="Order.status.processed"/></p></div>
  if (status === 4) return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 14, fontWeight: '600', color: '#be4d25' }}><IntlMessages id="Order.status.supplemented"/></p></div>
  if (status === 5) return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px' }} className="my-2"><p style={{ margin: '0 auto', fontSize: 14, fontWeight: '600', color: '#93F8B3' }}><IntlMessages id="Order.status.Done"/></p></div>

}

else{
  let Sttsta=this.props.OrderStatusList.filter(item=>{
    return parseInt(item.Value) === parseInt(status) && item.Meta !=="HO.KLAR" && item.Meta !=="HC.KLAR" && (parseInt(item.Afid) === parseInt(Afid) || parseInt(item.id) === 0)
  }) 
  return (
    // <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px',backgroundColor:isEmpty(Sttsta)?'#e6e6e6':Sttsta[0].Color  }} 
    // className=" text-white my-2">
    //   <p style={{ margin: '0 auto', fontSize: 14 }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p>
    // </div>

<div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 text-white">
  <div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor:isEmpty(Sttsta)?'#e6e6e6':Sttsta[0].Color, marginRight: '15px' }}></div>
  <p style={{ fontSize: 14 , fontWeight: '600', textAlign: 'left',color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p>
</div>
    
  )
}
}
render() {
  const { classes } = this.props;
  return (<>{
    this.state.done === false? <div style={{display: "flex",flexFlow: "column",width: "95%"}}>
    <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
    <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
    <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
    <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
    </div>
    :
    <div className={classes.root}
    style={{width:'95%',overflow: "scroll", height: '100%'}}>
  {/* <div className="table-responsive-material" style={{width:'95%',overflowY: "auto",height: "230px"}}> */}
      <Table>
        <TableBody>
          {!isEmpty(this.state.DashOrderList)?this.state.DashOrderList.map(n => {
            return (
              <TableRow key={n.index}>
                <TableCell align="left" style={{ paddingTop: '5px', paddingBottom: '0', color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor, borderBottom: `1px solid ${isUndefined(this.props.FontColor)?'#ffffff80':this.props.FontColor}` }}>{this.getStalus(n.Status,n.Hogia,n.Afid)}</TableCell>
                <TableCell align="left" style={{ paddingTop: '0', paddingBottom: '0', color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor, borderBottom: `1px solid ${isUndefined(this.props.FontColor)?'#ffffff80':this.props.FontColor}` }}>{n.AF_kundnamn}</TableCell>
                <TableCell align="right" style={{ paddingTop: '5px', paddingBottom: '0', color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor, borderBottom: `1px solid ${isUndefined(this.props.FontColor)?'#ffffff80':this.props.FontColor}` }}>{n.Regdate}</TableCell>
              </TableRow>
            );
          }):""}
           

        </TableBody>
      </Table>
    </div>}</>
  )}
}
export default connect(
  mapStateToProps,mapDispatchToProps
)(withStyles(useStyles)(OrderTable));

